import React, { useContext, useState } from 'react';
import { Box, Button, Menu } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { faEllipsis } from '@fortawesome/pro-regular-svg-icons';
import { VerticalDivider } from '@europrocurement/flexy-components';
import {
    DossierActionContext,
    DossierRoutingContext,
    SelectedDossierContext,
} from '../../../providers';
import { useDossierActionMenuItems } from '../../../hooks';

type DetailDossierActionMenuProps = {
    source: 'FRONT' | 'BACK';
};
const DetailDossierActionMenu: React.FunctionComponent<DetailDossierActionMenuProps> = function ({
    source = 'FRONT',
}) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { triggerAction } = useContext(DossierActionContext);
    const { dossier, refreshDossier } = useContext(SelectedDossierContext);
    const { getOrderDuplicateRoute } = useContext(DossierRoutingContext);

    const { getDossierDetailActionBySource } = useDossierActionMenuItems({
        dossier,
        triggerAction,
        setAnchorEl,
        refreshDossier,
        getOrderDuplicateRoute,
    });

    const handleClickContextualMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const actions = getDossierDetailActionBySource(source);

    return (
        <Box>
            {actions.length > 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <VerticalDivider sx={{ margin: '0px 10px' }} />

                    <Button
                        id="toolbar-contextual-menu-btn"
                        aria-controls={open ? 'toolbar-contextual-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClickContextualMenu}
                        sx={{ color: 'text.gris70' }}
                    >
                        <Box>
                            <FaOptionIcon
                                icon={faEllipsis}
                                size="lg"
                            />
                        </Box>
                    </Button>
                    <Menu
                        id="toolbar-contextual-menu"
                        aria-labelledby="toolbar-contextual-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{ sx: { py: 0 } }}
                    >
                        {actions.map((action) => action)}
                    </Menu>
                </Box>
            )}
        </Box>
    );
};

export default DetailDossierActionMenu;
